import { useTranslations } from 'next-intl';
import { AuthHalfModal } from '@/components/layout/modals/auth/AuthHalfModal';
import { MigrationNotificationModal } from '@/components/layout/modals/auth/MigrationNotificationModal';
import { useAuthModal } from '@/components/layout/modals/auth/hooks/use-auth-modal';
import { Button } from '@/components/ui/button/Button';
import { LoadingButton } from '@/components/ui/button/LoadingButton';

export const GuestNavigation = () => {
  const t = useTranslations();
  const {
    activeModal,
    setActiveModal,
    closeAuthModal,
    handleIdpSignIn,
    handleStartMigration,
    loginDisabled,
  } = useAuthModal();

  return (
    <div className='flex h-bottom-nav items-center justify-between gap-2 bg-kl-dark px-5 text-white'>
      {loginDisabled ? (
        // TODO:ローディング中のUIのデザインが決まったら変更する
        <LoadingButton
          fullWidth
          dark
          zIndex={10}
          className='bg-kl-gradient relative w-full after:absolute after:inset-0 after:rounded-full after:bg-black after:bg-opacity-50'
        />
      ) : (
        <div className='flex gap-2'>
          <Button
            label={t('common-sign_up')}
            color='gradient'
            onClick={() => setActiveModal('register')}
          />
          <Button
            label={t('common-login')}
            variant='outline'
            color='gradient'
            onClick={() => setActiveModal('login')}
          />
        </div>
      )}
      <AuthHalfModal
        isOpen={activeModal === 'register' || activeModal === 'login'}
        onClose={closeAuthModal}
        initialTab={activeModal === 'login' ? 'login' : 'register'}
        onClickStartMigration={() => setActiveModal('notification')}
        onOpenNextModal={handleIdpSignIn}
      />
      <MigrationNotificationModal
        isOpen={activeModal === 'notification'}
        onClose={closeAuthModal}
        onClick={handleStartMigration}
      />
    </div>
  );
};
